<template>
	<div id="wrapper">
		<SectionHeader/>
		<SectionHome/>
		<SectionAbout/>
		<SectionStatus/>
		<SectionInstallationAddons/>
		<SectionInstallationTeamspeak/>
		<SectionInstallationRun/>
		<SectionAdvices/>
		<SectionFaq/>
		<SectionVideo/>
		<SectionGallery/>
		<SectionQuotes/>
		<SectionFooter/>
		<SectionPhotoswipeControls/>
		<SectionPreloader/>
	</div>
</template>

<script>
	// import objects
	import {Init as SiteInit} from './assets/js/common.classes';
	import i18n from './i18n';
	import {params} from './params';

	// import CSS files
	import './assets/css/fonts.css';
	import './assets/css/base.css';
	import './assets/css/vendor.css';
	import './assets/css/main.css';
	import './assets/css/custom.css';

	// import templates
	import SectionHeader from './components/sections/Header';
	import SectionHome from './components/sections/Home';
	import SectionAbout from './components/sections/About';
	import SectionStatus from './components/sections/Status';
	import SectionInstallationAddons from './components/sections/InstallationAddons';
	import SectionInstallationTeamspeak from './components/sections/InstallationTeamspeak';
	import SectionInstallationRun from './components/sections/InstallationRun';
	import SectionAdvices from './components/sections/Advices';
	import SectionFaq from './components/sections/Faq';
	import SectionVideo from './components/sections/Video';
	import SectionGallery from './components/sections/Gallery';
	import SectionQuotes from './components/sections/Quotes';
	import SectionPreloader from './components/sections/Preloader';
	import SectionPhotoswipeControls from './components/sections/PhotoswipeControls';
	import SectionFooter from './components/sections/Footer';

	// export
	export default {
		name: 'App',
		i18n: i18n,
		data: function () {
			return {
				socials: params['socialButtons']
			}
		},
		components: {
			SectionHeader,
			SectionHome,
			SectionAbout,
			SectionStatus,
			SectionInstallationAddons,
			SectionInstallationTeamspeak,
			SectionInstallationRun,
			SectionAdvices,
			SectionFaq,
			SectionVideo,
			SectionGallery,
			SectionQuotes,
			SectionPreloader,
			SectionPhotoswipeControls,
			SectionFooter
		},
		mounted: function() {
			// init site
			SiteInit.addUserAgent();
			SiteInit.preloader();
			SiteInit.menuOnScrolldown();
			SiteInit.offCanvas();
			SiteInit.photoswipeGallery();
			SiteInit.masonry($('.s-works').find('.masonry'), true);
			SiteInit.clickSlider();
			SiteInit.smoothScroll();
			SiteInit.alertBoxes();
			SiteInit.aosInit();
			SiteInit.backToTop();
			SiteInit.advicesParticles();
		}
	}
</script>



// WEBPACK FOOTER //
// src/App.vue